<template>
  <div class="app-main-inner">
    <el-dialog
      v-if="!dialogDistroy"
      class="realSendReceiveDialog"
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :width="$selectByLang('360px', '400px')"
      top="5vh"
    >
      <el-form :label-width="$selectByLang('85px', '125px')" label-position="left">
        <el-form :label-width="$selectByLang('85px', '125px')" label-position="left">
          <!--收款方式-->
          <el-form-item :label="$t('WriteOff.paymentMethod')">
            <cargo-advance-select
              :clearable="false"
              :select-type="selectTypeNames.local_cache_ClearingConstants$AMOUNT_RECEIVE_TYPES"
              :cache="false"
              :default-value="receiveType"
              :static-options="receiveTypeArray"
              :style="formItemWidth"
              :tag-name="tagName"
              @parentCallBack="receiveTypeChangeHandler"
            />
          </el-form-item>
          <!--水单状态-->
          <el-form-item :label="$t('WriteOff.bankReceiptStatus')">
            <cargo-advance-select
              :select-type="selectTypeNames.local_cache_ClearingConstants$CASH_TRANSFER_STATES"
              callback-method-type="value"
              :default-value="cashTransferState"
              :callback-params="{key:'cashTransferState'}"
              :clearable="false"
              :style="formItemWidth"
              :tag-name="tagName"
              @parentCallBack="cashTransferStateChangeHandler"
            />
          </el-form-item>
          <!--我方银行-->
          <el-form-item :label="$t('WriteOff.ourSideBank')">
            <cargo-advance-select
              filterable
              :select-type="selectTypeNames.static_data_BankAccount"
              :cache="false"
              :method-params="{officeUuid:currentOfficeUuid}"
              :default-value="ourBankAccountId"
              :static-options="ourBankAccountArray"
              :custom-label="ourBankAccountLabel"
              :style="formItemWidth"
              options-width="450px"
              @parentCallBack="ourBankChangeHandler"
            />
          </el-form-item>
          <!--我方账号-->
          <el-form-item :label="$t('WriteOff.ourSideAccount')">
            <el-input v-model="ourBankAccountNo" :style="formItemWidth" />
          </el-form-item>
          <!--凭证号-->
          <el-form-item :label="$t('WriteOff.proofNo')">
            <el-input v-model="actualAmount.voucherNo" :style="formItemWidth" />
          </el-form-item>
        </el-form>
        <el-form :label-width="$selectByLang('85px', '125px')" label-position="left">
          <!--币种-->
          <el-form-item :label="$t('WriteOff.currency')">
            <cargo-advance-select
              filterable
              :select-type="selectTypeNames.basic_data_Currency"
              :default-value="currency"
              :clearable="false"
              :style="formItemWidth"
              @parentCallBack="currencyChangeHandler"
            />
          </el-form-item>
          <!--收/付款金额-->
          <el-form-item :label="$t('CargoMsg.Cargo_ReceiptAmount')" class="redLabel">
            <el-input-number
              v-model="actualAmount.amount"
              :disabled="isPrePayment"
              :min="0"
              :max="99999999"
              :precision="2"
              controls-position="right"
              :style="formItemWidth"
            />
          </el-form-item>
          <!--对方单位-->
          <el-form-item :label="$t('CargoMsg.Cargo_PaymentCompany')">
            <el-input v-model="actualAmount.paymentCompany" :style="formItemWidth" />
          </el-form-item>
          <!--结算对象-->
          <el-form-item v-show="isPrePayment" :label="$t('WriteOff.settleAccountsTo')">
            <cargo-company-select
              :method-params="{}"
              :default-value="Number(settlementCompanyId)||''"
              :tag-name="tagName"
              :custom-style="formItemWidth"
              @change="companyIdChangeHandler"
            />
          </el-form-item>
          <!--对方银行-->
          <el-form-item :label="$t('WriteOff.theOppositeSideBank')">
            <el-input v-model="actualAmount.companyBank" :style="formItemWidth" />
          </el-form-item>
          <!--对方账号-->
          <el-form-item :label="$t('WriteOff.theOppositeSideAccount')">
            <el-input v-model="actualAmount.companyBankAccount" :style="formItemWidth" />
          </el-form-item>
        </el-form>
        <!--收/付款日期-->
        <el-form-item :label="lbPayDate">
          <el-date-picker
            v-model="payReceiveDate"
            value-format="yyyy-MM-dd"
            type="date"
            :clearable="false"
            :default-value="new Date()"
            :style="{width:'150px', paddingRight: '10px'}"
          />
          <el-checkbox v-show="showPublish" v-model="isPublish" :style="{width:'50px'}">{{ $t('CargoMsg.Cargo_Publish') }}</el-checkbox>
        </el-form-item>
        <!--用途-->
        <el-form-item :label="$t('Payment.purpose')">
          <el-input v-model="actualAmount.purpose" type="textarea" :rows="3" :style="formItemWidth" />
        </el-form-item>
        <!--交易附言-->
        <el-form-item :label="$t('Payment.postscript')">
          <el-input v-model="actualAmount.postscript" type="textarea" :rows="3" :style="formItemWidth" />
        </el-form-item>
        <!--备注-->
        <el-form-item :label="$t('Payment.remarks')">
          <el-input v-model="actualAmount.remark" type="textarea" :rows="3" :style="formItemWidth" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <!--保存并新增-->
        <el-button v-show="!isPrePayment" type="primary" @click="saveOrSaveAndAddHandler(false)">{{ $t('Payment.saveAndAdd') }}</el-button>
        <el-button type="primary" @click="saveOrSaveAndAddHandler(true)">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import writeOffSearch from '@/views/cargo/v0/Clearing/components/Writeoff/writeOffSearch'
import { getLoading } from '@/utils/utilBaseElement'
import * as actualAmountApi from '@/api/clearing/actualAmount'
import { getBankAccountList } from '@/api/bankAccount'
import { AMOUNT_RECEIVE_TYPES } from '@/class/cargo/model/parameters/ClearingConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import $store from '@/store'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import lang from '@/lang'

export default {
  name: 'BankSlipWindow',
  components: { searchItem, cargoAdvanceSelect, writeOffSearch, cargoCompanySelect },
  props: {
    visible: { type: Boolean, default: false },
    params: { type: Object, default: null },
    title: { type: String, default: lang.t('Clearing.WaterBillRegistration') },
    showPublish: { type: Boolean, default: false },
    ar: { type: Boolean, required: true },
    isPrePayment: { type: Boolean, required: false } // 是否是预收款认领
  },
  data() {
    return {
      dialogDistroy: false, // 新增实收实付对话框销毁
      formItemWidth: 'width: 230px;', // 表单输入控件宽度统一控制
      innerVisible: false,
      actualAmount: {}, // 表单数据
      isPublish: false, // 是否发布
      ourBankAccountArray: [], // 我方银行选项
      receiveTypeArray: [], // 收/付款方式选项
      selectTypeNames: TYPE_NAMES,
      // 新增/编辑 收付款表单参数

      payReceiveDate: null,
      receiveType: null, // 收/付款方式
      cashTransferState: null, // 水单状态
      ourBankAccountId: 0, // 我方银行Id
      ourBankAccountNo: '', // 我方银行账号
      currency: '', // 币种
      txtPayCompany: '', // 来款单位
      settlementCompanyId: '' // 结算对象(公司)
    }
  },
  computed: {
    lbPayReceive() {
      return this.ar ? this.$t('Payment.receipt') : this.$t('Payment.payment')
    },
    // 收付款金额
    lbAmount() {
      return this.ar ? this.$t('WriteOff.receiptAmount') : this.$t('WriteOff.paymentAmount')
    },
    // 收付款日期
    lbPayDate() {
      return this.ar ? this.$t('Payment.receiptDate') : this.$t('Payment.paymentDate')
    },
    currentOfficeUuid() {
      return this.$store.getters.currentOfficeUuid
    },
    tagName() {
      return this.$i18n.locale === 'zh' ? 'chineseName' : 'englishName'
    },
    i18nLocale() {
      return this.$i18n.locale
    }
  },
  watch: {
    visible(val) {
      this.innerVisible = val
    },
    innerVisible(val) {
      if (val) {
        this.actualAmount = this.params ? this.params : {}
        this.initData()
      } else {
        this.$emit('update:visible', val)
      }
    },
    async currentOfficeUuid(val) {
      // 分公司切换时，初始化银行列表
      this.ourBankAccountArray = await getBankAccountList(val).then(res => res.data)
      this.ourBankAccountId = 0
    },
    i18nLocale() {
      // 国际化切换时销毁对话框
      this.dialogDistroy = true
      setTimeout(() => {
        this.dialogDistroy = false
      }, 1)
    }
  },
  async created() {
    // 初始化银行列表
    this.ourBankAccountArray = await getBankAccountList(this.$store.getters.currentOfficeUuid).then(res => res.data)
    // 初始化收付类型
    for (const value of AMOUNT_RECEIVE_TYPES.values()) {
      this.receiveTypeArray.push(value)
    }
  },
  methods: {
    initData() {
      this.isPublish = false
      const actualAmount = this.actualAmount
      if (actualAmount) {
        // 结算对象(公司)
        this.settlementCompanyId = actualAmount.accountId
        // 收/付款方式
        this.receiveType = actualAmount.type || 0
        // 水单状态
        this.cashTransferState = actualAmount.cashTransferState || 0
        // 币种
        this.currency = actualAmount.currency
        this.payReceiveDate = actualAmount.payReceiveDate
        // 我方银行AccountId
        this.ourBankAccountId = 0
        this.ourBankAccountNo = actualAmount.ourBankAccount
        if (this.ourBankAccountArray) {
          const bank = this.ourBankAccountArray.find(bank => bank.accountNo === actualAmount.ourBankAccount && bank.currency === actualAmount.ourBankCurrency)
          this.ourBankAccountId = bank ? bank.accountId : 0
        }
      }
    },
    // 保存/保存并新增 按钮事件
    async saveOrSaveAndAddHandler(onlySave) {
      if (this.validateForm()) {
        if (onlySave && this.receiveType !== 0 && this.actualAmount.ourBankAccount === null) {
          this.$confirm(this.$t('CargoMsg.Cargo_OurBankIsEmptySaveBankReceipt'), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('Clearing.Confirm'),
            cancelButtonText: this.$t('Clearing.Cancel'),
            type: 'warning'
          }).then(() => {
            this.save(onlySave)
          })
        } else {
          await this.save(onlySave)
        }
      }
    },
    async save(onlySave) {
      this.loading = getLoading()
      this.fillForm()
      const actualAmount = this.actualAmount
      const date = actualAmount.payReceiveDate
      actualAmount.branchId = this.$store.getters.currentOfficeId
      // CARGO-26433 水单认领模块支付类型显示错误
      if (!this.isPrePayment) {
        actualAmount.ar = true
      }
      await actualAmountApi.saveActualAmount(actualAmount).then(resp => {
        this.saveResultHandler(onlySave, date)
        this.$emit('refresh')
      }).catch(() => this.faultHandler()).finally(() => {
        this.loading.close()
      })
      if (onlySave) {
        this.innerVisible = false
      }
    },
    // 表单验证
    validateForm() {
      if (!this.currency) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectCurrency'))
        return false
      } else if (!this.actualAmount.amount) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterPaidInAmount'))
        return false
      } else if (!this.payReceiveDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterPaidInDate'))
        return false
      }
      if (this.isPrePayment && this.actualAmount.accountId === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSettlingParty'))
        return false
      }
      return true
    },
    // 保存 成功回调
    async saveResultHandler(onlySave, date) {
      this.actualAmount = {}
      if (!onlySave) { // 新增并保存以后，要初始化变量
        this.isPublish = false
        this.payReceiveDate = date
        this.actualAmount = {} // 表单数据
        this.ourBankAccountId = 0 // 我方银行Id
        this.ourBankAccountNo = '' // 我方银行账号
        this.currency = 'RMB' // 币种
        this.txtPayCompany = '' // 来款单位
      }
    },
    // 保存并新增 成功回调
    saveAndCreateResultHandler() {
      const model = {}
      const actualAmount = this.actualAmount
      // 结算对象
      model.accountId = actualAmount.accountId
      // 收款方式
      model.type = actualAmount.type
      // 我方银行
      model.ourBank = actualAmount.ourBank
      // 我方账号
      model.ourBankAccount = actualAmount.ourBankAccount
      // 我方币种
      model.ourBankCurrency = actualAmount.ourBankCurrency
      // 币种
      model.currency = actualAmount.currency
      // 日期
      model.payReceiveDate = actualAmount.payReceiveDate

      model.ar = this.ar
      model.branchId = this.$store.getters.currentOfficeId
      const localCurrency = RateUtil.localCurrencyByOffice()
      model.currency = localCurrency
      this.actualAmount = model
    },
    closedHandler() {

    },
    /** 下拉框change事件 **/
    companyIdChangeHandler(data) {
      this.settlementCompanyId = StrUtils.isEmpty(data.cmpIdx) ? 0 : data.cmpIdx
      this.actualAmount.accountId = StrUtils.isEmpty(data.cmpIdx) ? 0 : data.cmpIdx
    },
    // 收款方式
    receiveTypeChangeHandler(data) {
      this.receiveType = data.code
      if (data.code === 0) {
        this.ourBankAccountId = 0
        this.ourBankAccountNo = ''
        this.actualAmount.ourBank = ''
        this.actualAmount.ourBankAccount = ''
        this.actualAmount.ourBankCurrency = ''
      } else {
        this.checkCurrencyBankAccount(this.currency, true)
      }
    },
    // 水单状态
    cashTransferStateChangeHandler(data) {
      this.cashTransferState = data.value
      this.actualAmount.cashTransferState = data.value
    },
    // 我方银行
    ourBankChangeHandler(data) {
      this.actualAmount.ourBank = data.bankChineseName
      this.actualAmount.ourBankAccount = data.accountNo
      this.ourBankAccountNo = data.accountNo
      this.actualAmount.ourBankCurrency = data.currency || ''
      this.ourBankAccountId = data.accountId
    },
    // 币种
    currencyChangeHandler(data) {
      this.currency = data.code
      this.actualAmount.currency = data.code
      this.checkCurrencyBankAccount(this.currency, true)
    },
    /**
     * 根据各种自动关联账号
     * @param currency 页面币种
     * @param isChange 是否手动操作
     */
    checkCurrencyBankAccount(currency, isChange) {
      let bankAccount = this.getCurrencyBankAccount(currency, true)
      if (bankAccount == null) bankAccount = this.getCurrencyBankAccount(currency, false)
      if (bankAccount && isChange) {
        this.actualAmount.ourBank = bankAccount.bankChineseName
        this.actualAmount.ourBankAccount = bankAccount.accountNo
        this.actualAmount.ourBankCurrency = bankAccount.currency
        this.ourBankAccountId = bankAccount.accountId
        this.ourBankAccountNo = bankAccount.accountNo
      }
    },
    // 获取默认账号
    getCurrencyBankAccount(currency, isDefault) {
      let bank = null
      for (const bankAccount of this.ourBankAccountArray) {
        if (currency === bankAccount.currency) {
          if (!isDefault) {
            bank = bankAccount
            break
          } else if (bankAccount.defaultPayment) {
            bank = bankAccount
            break
          }
        }
      }
      return bank
    },
    faultHandler() {
      this.$message.warning(this.$t('CargoMsg.Cargo_SystemBusyPRL'))
    },
    fillForm() {
      this.fillModel()
      const actualAmount = this.actualAmount
      actualAmount.remainAmount = actualAmount.amount
      actualAmount.ourBankAccount = this.ourBankAccountNo
      actualAmount.isPrepay = true
      actualAmount.accountId = this.settlementCompanyId
      this.actualAmount = actualAmount
    },
    fillModel() {
      if (!this.actualAmount) return
      const actualAmount = this.actualAmount
      actualAmount.type = this.receiveType
      actualAmount.payReceiveDate = this.payReceiveDate
      actualAmount.currency = this.currency
      actualAmount.cashTransferState = this.cashTransferState
      actualAmount.prePayment = this.isPrePayment
      actualAmount.isBankSlip = true
      actualAmount.returnAmount = 0
      actualAmount.preAmount = 0
      actualAmount.preBankSlipState = 0
      if (this.showPublish) {
        actualAmount.releaseState = this.isPublish ? 1 : 0
      }
      if (this.isPrePayment) {
        actualAmount.verificationBy = $store.getters.userId
        actualAmount.verificationDate = new Date()
        actualAmount.verfiedAmount = actualAmount.amount
        actualAmount.bankSlipReceiveBy = $store.getters.userId
        actualAmount.preBankSlipState = 2
        actualAmount.preAmount = actualAmount.amount
      }
    },
    ourBankAccountLabel(bankAccount) {
      if (bankAccount) {
        if (bankAccount.description && bankAccount.description.trim()) {
          return '[' + bankAccount.code + ']' + '[' + bankAccount.currency + ']' + bankAccount.bankChineseName + '(' + bankAccount.description + ')'
        } else {
          return '[' + bankAccount.code + ']' + '[' + bankAccount.currency + ']' + bankAccount.bankChineseName
        }
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
.realSendReceiveDialog {
  .el-dialog__body {
    padding: 10px 20px !important;
  }
}

.redLabel .el-form-item__label {
  color: rgba(203, 12, 41, 0.98) !important
}
</style>
